import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useSearchParams } from "react-router-dom";
import {Footer} from "@/components/SiteFooter";
import WorkflowCustomizer from "@/components/WorkflowCustomizer";
import { initialModules, EnhancedModule } from "@/data/modules";
import { NavBar } from "@/components/navbar";

const CustomizeWorkflowPage = () => {
    const [searchParams] = useSearchParams();
    const [modules, setModules] = useState<EnhancedModule[]>(initialModules);
    
    useEffect(() => {
        // Check if we have module and submodule params
        const moduleId = searchParams.get('module');
        const submoduleId = searchParams.get('submodule');
        
        if (moduleId && submoduleId) {
            // Clone the initial modules to avoid modifying the original
            const preselectedModules = JSON.parse(JSON.stringify(initialModules)) as EnhancedModule[];
            
            // Find the module and submodule
            const moduleIndex = preselectedModules.findIndex(m => m.id === moduleId);
            
            if (moduleIndex !== -1) {
                // Find the submodule within that module
                const submoduleIndex = preselectedModules[moduleIndex].subModules.findIndex(
                    sm => sm.id === submoduleId
                );
                
                if (submoduleIndex !== -1) {
                    // First reset all submodules to inactive
                    preselectedModules.forEach(module => {
                        module.subModules.forEach(sm => {
                            sm.active = false;
                        });
                    });
                    
                    // Set this submodule to active
                    preselectedModules[moduleIndex].subModules[submoduleIndex].active = true;
                    setModules(preselectedModules);
                    
                    console.log(`Preselected module ${moduleId}, submodule ${submoduleId} is now active`);
                }
            }
        }
    }, [searchParams]);
    
    return (
        <>
            <Helmet>
                <title>Customize Your Workflow | ESGWize</title>
                <meta name="description" content="Customize and visualize your workflow processes"/>
            </Helmet>
            <div className="min-h-screen flex flex-col pt-16">
                <NavBar/>
                <main className="flex-grow overflow-hidden">
                    <div className="container mx-auto px-4 py-8">
                        <div className="max-w-5xl mx-auto">
                            <WorkflowCustomizer initialModules={modules}/>
                        </div>
                    </div>
                </main>
            </div>
        </>
    );
};

export default CustomizeWorkflowPage;
